/**
 * 系统公告管理 接口
 */
 import axios from '../request';
 export default{
    /**
     * 系统公告
     */
    // 查询系统公告信息
    searchNotices: params =>
        axios.post('/engineering/notice/noticeList', params),
    // 添加系统公告信息
    insertNotices: params =>
        axios.post('/engineering/notice/noticeInsert', params),
    // 修改系统公告信息
    updateNotices: params =>
        axios.post('/engineering/notice/noticeUpdate', params),
    // 系统公告信息详情
    detailsNotices: params =>
        axios.get('/engineering/notice/noticeInfo', {params}),
    // 删除系统公告信息
    deleteNotices: params =>
        axios.get('/engineering/notice/noticeDel', {params}),
    // 上传图片
    uploadImageNotices: params =>
        axios.post('/file/file/upload', params),
    // 上架或者下架
    putDownNotices: params =>
        axios.post('/engineering/notice/noticeOff', params),

 }